import React from "react";
import LeadForm from "../components/LeadForm";

const recoveryServices = [
  {
    icon: "bi bi-hdd",
    title: "Hard Drive Recovery",
    text: "Help recovering files from failing, corrupted, or accidentally formatted internal and external drives.",
  },
  {
    icon: "bi bi-usb-drive",
    title: "USB & Memory Card Recovery",
    text: "Support for flash drives, camera cards, and removable storage devices that are unreadable or damaged.",
  },
  {
    icon: "bi bi-laptop",
    title: "Laptop & Desktop Files",
    text: "Recovery assistance for documents, photos, work files, and user folders after crashes or system failures.",
  },
  {
    icon: "bi bi-cloud-arrow-up",
    title: "Backup Setup",
    text: "Prevent future data loss with cloud backup, external backup, and simple recovery planning.",
  },
];

const DataRecovery = () => {
  return (
    <>
      <section
        id="hero"
        className="d-flex align-items-center"
        style={{
          backgroundImage:
            "linear-gradient(135deg, rgba(15, 23, 42, 0.55) 0%, rgba(30, 41, 59, 0.42) 100%), url('/assets/img/hero.webp')",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundBlendMode: "overlay",
        }}
      >
        <div className="container">
          <div className="row">
            <div
              className="col-lg-8 d-flex flex-column justify-content-center pt-4 pt-lg-0"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <h1>Data Recovery Services</h1>
              <h2>
                Fast help for lost files, corrupted drives, accidental deletion,
                and backup restoration.
              </h2>
            </div>
          </div>
        </div>
      </section>

      <section className="about">
        <div className="container" data-aos="fade-up">
          <div className="row content">
            <div className="col-lg-8">
              <h3>Recover important files with careful, guided support</h3>
              <p>
                IT Assist Experts helps customers recover documents, photos,
                business files, and device data after storage failures,
                accidental deletion, malware issues, or operating system
                problems. We start with a careful diagnosis and explain the
                safest next step before making changes.
              </p>
              <ul>
                <li>
                  <i className="ri-check-double-line"></i>
                  Recovery assistance for laptops, desktops, external drives,
                  USB drives, and memory cards.
                </li>
                <li>
                  <i className="ri-check-double-line"></i>
                  Help with deleted files, inaccessible folders, corrupted
                  partitions, and failed system boots.
                </li>
                <li>
                  <i className="ri-check-double-line"></i>
                  Backup setup after recovery so your most important files are
                  protected going forward.
                </li>
              </ul>
            </div>
            <div className="col-lg-4 pt-4 pt-lg-0 d-flex align-items-stretch forms">
              <LeadForm
                title="Request Data Recovery"
                subtitle="Tell us what happened and we will get back to you."
                source="data-recovery-page"
              />
            </div>
          </div>
        </div>
      </section>

      <section id="services" className="services section-bg">
        <div className="container" data-aos="fade-up">
          <div className="section-title">
            <h2>What We Can Help Recover</h2>
          </div>
          <div className="row">
            {recoveryServices.map((service, index) => (
              <div
                className={`col-xl-3 col-md-6 d-flex align-items-stretch ${
                  index > 0 ? "mt-4 mt-md-0" : ""
                }`}
                data-aos="zoom-in"
                data-aos-delay={(index + 1) * 100}
                key={service.title}
              >
                <div className="icon-box">
                  <i
                    className={service.icon}
                    style={{
                      fontSize: "48px",
                      color: "#2563eb",
                      marginBottom: "20px",
                    }}
                  ></i>
                  <h4>
                    <span>{service.title}</span>
                  </h4>
                  <p>{service.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="faq">
        <div className="container" data-aos="fade-up">
          <div className="section-title">
            <h2>Before You Try Anything Else</h2>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-9">
              <ul>
                <li>Stop using the affected drive or device if files are missing.</li>
                <li>Avoid reinstalling the operating system before recovery is assessed.</li>
                <li>Do not save new files to the same drive you want recovered.</li>
                <li>Contact us with the device type and what happened.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DataRecovery;
